import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./HelpHeader.module.scss";

const HelpHeader: React.FC = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.headerSection}>
      <div className={styles.headerBackground}>
        <div className={styles.backgroundPattern}></div>
      </div>
      
      <div className={styles.headerContent}>
        <button className={styles.backButton} onClick={goBack}>
          <span className={styles.backIcon}>←</span>
          Go Back
        </button>
        
        <div className={styles.titleSection}>
          <h1 className={styles.helpTitle}>Help & Support</h1>
          <p className={styles.helpSubtitle}>
            Find answers to your questions and get the support you need
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpHeader;